// @ts-nocheck
import action from 'utils/actionCreators';

export const GET_PROJECT_BUDGET_REQUEST = 'GET_PROJECT_BUDGET_REQUEST';
export const GET_PROJECT_BUDGET_SUCCESS = 'GET_PROJECT_BUDGET_SUCCESS';
export const GET_PROJECT_BUDGET_FAILURE = 'GET_PROJECT_BUDGET_FAILURE';

export const getProjectBudgetRequest = action(
  GET_PROJECT_BUDGET_REQUEST,
  'payload',
);
export const getProjectBudgetSuccess = action(GET_PROJECT_BUDGET_SUCCESS);
export const getProjectBudgetFailure = action(GET_PROJECT_BUDGET_FAILURE);

export const SELECT_PROJECT = 'SELECT_PROJECT';

export const SELECT_PROJECT_BUDGET_TAB = 'SELECT_PROJECT_BUDGET_TAB';

export const SELECT_PROJECT_BUDGET_PAGE = 'SELECT_PROJECT_BUDGET_PAGE';

export const UPDATE_TAB_EDITED_STATE = 'UPDATE_TAB_EDITED_STATE';

export const selectProject = action(SELECT_PROJECT, 'payload');

export const selectProjectBudgetTab = action(
  SELECT_PROJECT_BUDGET_TAB,
  'payload',
);

export const selectProjectBudgetPage = action(
  SELECT_PROJECT_BUDGET_PAGE,
  'payload',
);

export const updateTabEditedState = action(UPDATE_TAB_EDITED_STATE, 'payload');
